 <template>
  <div>
    <con-tab @TwoClick="TwoClick"></con-tab>
    <!-- 各个专项 -->
    <SpecialNel></SpecialNel>
  </div>
</template>

<script>
import ConTab from "../../components/common/ConTab";
import SpecialNel from "./base/SpecialNel";
export default {
  name: "Special",
  data() {
    return {};
  },
  created() {},
  methods: {
    TwoClick(item) {
       this.ConList = item;
    },
  },
  components: {
    ConTab,
    SpecialNel,
  },
};
</script>

<style scoped>
</style>
